import * as React from "react";
import type { SVGProps } from "react";
const SvgRefreshIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="refresh_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M262.912 139.008a426.667 426.667 0 0 1 507.435 70.912l125.61 118.059V170.667a42.667 42.667 0 1 1 85.334 0v256.896a42.539 42.539 0 0 1-42.667 41.77h-256a42.667 42.667 0 1 1 0-85.333h148.31L711.466 271.744a341.333 341.333 0 1 0 79.872 354.09 42.667 42.667 0 0 1 80.426 28.331 426.667 426.667 0 1 1-608.853-515.157z"
    />
  </svg>
);
export default SvgRefreshIcon;
